import { ID_NAMES } from '../../env';
import { messagesOver } from '../bubble';
import chatMessages from './messages';
import chatHeader from '../chat/header';
import chatCta from '../chat/cta';
import { videoInit } from '../messageTypes/video';
import { iframeManifestCheck } from '../messageTypes/iframe';



const showMessages = () => {

    const chat = document.getElementById(ID_NAMES.CHAT)
    chat.append(chatHeader())
    chat.append(chatMessages())
    chat.append(chatCta())

    //LOOP THROUGH MESSAGES
    const messageDivs = document.querySelectorAll('.chatheadMessage');
    const bubble = document.getElementById(ID_NAMES.BUBBLE_INSIDE)

    setTimeout(() => {

        let count = 0;
        bubble.style.transform = "scale(1)";

        setTimeout(() => {

            messageDivs.forEach(div => div.classList.add('chatheadScale'))
            videoInit();
            iframeManifestCheck();

        }, 350)

        const messageInterval = setInterval(() => {

            const currentMessage = messageDivs[count];

            if (!currentMessage) {
                clearInterval(messageInterval)
                messagesOver()
                return
            }

            //DISTANCE OF THE MESSAGE, TO MOVE THE BUBBLE
            const distanceTop = currentMessage.offsetTop;
            bubble.style.transform = `translateY(${distanceTop}px) scale(1)`;

            setTimeout(() => {
                currentMessage.classList.add('active');
                count++;
            }, 300)

        }, 1100)

    }, 700)

}

export default showMessages